<template>
  <div class="toast"
       v-show="isShow">
    <div v-if="type === 'loading'||type === 'error'||type === 'colorfulError'||type === 'success'||type === 'colorfulSuccess'|| type === 'violations'"
         class="mask"
         @touchmove.prevent.stop>
    </div>
    <div :class="['toast_info',type === 'error'?'error':'',type === 'colorfulError'?'colorfulError':'',type === 'success'?'success':'',type === 'colorfulSuccess'?'colorfulSuccess':'',type === 'loading'?'loading':'',type === 'tip'?'tip':'']">
      <div class="loading-icon"
           v-show="type === 'loading'">
        <img src="https://s-test.kcimg.cn/topic/images/38-carsisterinlaw/loading.png"
             class="no-click-img">
      </div>
      <i class="icon-success"
         v-show="type === 'success'">&#xe9fb;</i>
      <i v-show="type === 'colorfulSuccess'">&#xea00;</i>
      <i class="icon-error"
         v-show="type === 'error'">&#xe9fd;</i>
      <i class=" icon-error"
         v-show="type === 'colorfulError'">&#xea01;</i>
      <p class="text-content"
         v-if="text"
         v-html="text"></p>
      <p class="success-tip"
         v-show="type === 'success'"><span></span></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      default: false
    },
    text: {
      default: ''
    },
    infoShow: {
      default: true
    },
    time: {
      default: 0
    },
    type: {
      default: ''
    }
  },
  data: () => ({}),
  created () {
    setTimeout(res => {
      this.isShow = false
    }, this.time)
  },
  methods: {
    hidePop () {
      this.isShow = false
    }
  }
}
</script>
<style scoped>
.toast {
  z-index: 10002;
  position: relative;
}
.mask {
  position: fixed;
  z-index: 10003;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(23, 24, 26, 0.6);
}
.toast_info {
  position: fixed;
  z-index: 10004;
  padding: 10px;
  min-width: 240px;
  min-height: 100px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  box-sizing: border-box;
  text-align: center;
  border-radius: 15px;
  font-size: 16px;
  color: #17181a;
  line-height: 30px;
}
.toast_info i {
  display: block;
  margin: 30px auto 20px;
  font-family: "template";
  color: #fff;
  font-size: 80px;
  line-height: 80px;
}
.toast p {
  font-weight: bold;
  color: #fff;
  line-height: 40px;
  font-size: 28px;
  letter-spacing: 0;
  text-align: center;
  width: 100%;
  word-break: break-all;
}
.toast .btn {
  display: block;
  width: 340px;
  height: 80px;
  font-size: 28px;
  color: rgba(255, 255, 255, 1);
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 32px;
  cursor: pointer;
}
/* loading */
.toast_info.loading {
  min-height: 220px;
  width: 240px;
  padding: 24px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 16px;
}
.loading-icon {
  margin: 0 auto 16px;
  width: 64px;
  height: 64px;
  background: transparent;
  animation: spin 1s linear infinite;
}
.loading-icon img {
  width: 100%;
  height: 100%;
}
.toast_info.loading p {
  font-size: 28px;
  color: #ffffff;
}
/* tip */
.toast_info.tip {
  min-width: 176px;
  max-width: 400px;
  width: auto;
  height: auto;
  padding: 24px;
  background: rgba(23, 24, 26, 0.7);
  border-radius: 16px;
  min-height: 88px;
}
.toast_info.tip p {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
/* error */
.toast .success,
.toast .error {
  min-height: 220px;
  width: 240px;
  background: rgba(23, 24, 26, 0.7);
  border-radius: 16px;
}
.toast_info.error i {
  color: #fff;
}
/* success */
.toast .success-tip {
  width: 100%;
  text-align: center;
  height: 24px;
  font-size: 28px;
  line-height: 28px;
  margin-top: 13px;
  color: #fff;
}
/* colorfulSuccess */
.toast .colorfulSuccess,
.toast .colorfulError {
  width: 240px;
  min-height: 220px;
  background: #ffffff;
  border-radius: 16px;
}
.toast_info.colorfulSuccess p,
.toast_info.colorfulError p {
  color: rgba(23, 24, 26, 0.9);
}

.toast_info.colorfulSuccess i {
  color: rgb(100, 194, 103);
}
.toast_info.colorfulError i {
  color: #ed5f48;
}
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>
